"use client";

import { Header } from "@/components/shared/public";
import { useTranslations } from "next-intl";

const Head = () => {
  const tC = useTranslations("common");

  return <Header title={tC("salesOptimizedFloorPlans")} />;
};

export default Head;
